export default "__VITE_ASSET__D1f6t18z__"